import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WveInputSelect from 'SharedComponents/WveInputs/WveInputSelect/WveInputSelect';
import { flatEaseTypes } from 'SharedComponents/WveInputs/constants';

const EASE_TIMINGS = [
  'InOut',
  'In',
  'Out',
];
const EASE_TYPE_VALUES = [
  'Linear',
  'Circ',
  'Power1',
  'Power2',
  'Power3',
  'Power4',
  'Elastic',
  'Bounce',
  'SlowMo',
];
const EASE_TYPE_LABELS = [
  'None',
  'Circle',
  'Power1',
  'Power2',
  'Power3',
  'Power4',
  'Spring',
  'Bounce',
  'Slow-Mo',
];

class WveInputEase extends Component {
  handleUpdateEaseType = (e) => {
    const { onChange, value } = this.props;
    const easeTiming = value.toString().split('.')[1];
    onChange(`${e.value}.${easeTiming}`);
  };
  handleUpdateEaseTiming = (e) => {
    const { onChange, value } = this.props;
    const easeType = value.toString().split('.')[0];
    onChange(`${easeType}.ease${e.value}`);
  };
  render() {
    const { value, disabled } = this.props;

    const ease = value.toString().split('.');
    const easeType = (ease[0] !== 'none') ? ease[0] : 'Linear';
    const easeTiming = ease[1] ? ease[1].replace('ease', '') : '';
    const disableEaseTiming = disabled || flatEaseTypes.includes(easeType);
    return (
      <div
        className="wve-form-item-long wve-input-pair"
      >
        <WveInputSelect
          value={easeType}
          onChange={this.handleUpdateEaseType}
          values={EASE_TYPE_VALUES}
          options={EASE_TYPE_LABELS}
          disabled={disabled}
        />
        <WveInputSelect
          value={easeTiming}
          onChange={this.handleUpdateEaseTiming}
          options={EASE_TIMINGS}
          disabled={disableEaseTiming}
        />
      </div>
    );
  }
}

WveInputEase.propTypes = {
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WveInputEase;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputEase/WveInputEase.jsx